import { render, staticRenderFns } from "./donor-resub-recurring-plan.vue?vue&type=template&id=673b6b2e&scoped=true&"
import script from "./donor-resub-recurring-plan.vue?vue&type=script&lang=js&"
export * from "./donor-resub-recurring-plan.vue?vue&type=script&lang=js&"
import style0 from "./donor-resub-recurring-plan.vue?vue&type=style&index=0&id=673b6b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b6b2e",
  null
  
)

export default component.exports